import { Container, Tabs, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export const View = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname.toLowerCase();
  const activeTab = path.includes("members/members")
    ? "members"
    : path.includes("members/member-roles")
    ? "member-roles"
    : "members";

  return (
    <Container fluid>
      <Title mt="xl" weight={500} order={3}>
        {t("MEMBERS")}
      </Title>
      <Tabs
        mt="xl"
        value={activeTab}
        onTabChange={(value) => {
          navigate(`${value}`);
        }}
      >
        <Tabs.List mb="xl">
          <Tabs.Tab value="members">{t("MEMBERS")}</Tabs.Tab>
          <Tabs.Tab value="member-roles">{t("MEMBER_ROLES")}</Tabs.Tab>
        </Tabs.List>
        <Outlet />
      </Tabs>
    </Container>
  );
};
